// extracted by mini-css-extract-plugin
export default {"AppWelcome":"AppWelcome_AppWelcome__bomvF"};